import React, { useEffect } from 'react'
import LogoHeader from '../LogoHeader/LogoHeader';
import NewFooter from '../Footer/NewFooter';
import { useState } from 'react';
import Navigation from '../LogoHeader/Navigation';

function PageWrapper(props) {
	// const token = useState (props.token)
	const token = props.token
	return (
		<div className=''>
			<div className=''>
				<Navigation 	token = {token} 	search =  {props.search}
													setSearch = {props.setSearch} 
													category = {props.category} 
													setCategory= {props.setCategory} 
													page = {props.page} 
													setPage = {props.setPage}
													categories = {props.categories}
													setCategories = {props.setCategories}
													cartCount = {props.cartCount}
													setCartCount = {props.setCartCount}/>
			</div>
		  <div className='flex-row page'>
				{props.children}
		  </div>
		  
		</div>
	  )
}

export default PageWrapper